import { MatDialog } from "@angular/material/dialog";
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { catchError, map, throwError } from "rxjs";
import { AdvisorsService } from "src/app/services/advisors.service";
import { AdvisorModalComponent } from "../../common/advisor-modal/advisor-modal.component";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-advisors",
  templateUrl: "./advisors.component.html",
  styleUrls: ["./advisors.component.scss"],
})
export class AdvisorsComponent implements OnInit, AfterViewInit {
  @ViewChild("scrollContent") scrollContent!: ElementRef;

  scrollSpeed = 200;
  isLeftDisabled = true;
  isRightDisabled = false;

  advisors: any;
  advisorsByID: any;
  title: String = "";
  discription: String = "";

  advisorsExtra = [
    {
      id: 1,
      thumbnail:
        environment.assUrl + "assets/images/maestro/shovana-narayan.jpg",
      artist_name: "Shovana Narayan",
      about_us:
        "Padma Shri Shovana Narayan is known as one of the best Kathak dancers in the world who performs in India and around the world and has been under the tutelage of Pandit Birju Maharaj. She also performed before several Heads of States and Governments and has trained several Kathak artistes, some of whom are leading artistes of the young generation. As a Choreographer-Performer, Shovana Narayan has spearheaded and produced international collaborative works with leading dancers of Western Classical Ballet, Spanish Flamenco, Tap Dance, Buddhist Chants with Buddhist Monks and to the compositions of western classical composers. She was the Creative Director-Producer-Dancer of the first ever trilogy involving Western Classical Dance-Kathak-Spanish flamenco in The Dawn After in 1994. She delivered the opening & closing ceremonies of the Commonwealth Games Delhi in 2010 with a thundering success. Shovana is a dancer with a cause, deeply committed, involved and aware of people and their problems, and has been deeply contributing to the society by conceptualizing and choreographing several ballets on womens issues and other social concerns.",
      video: "",
    },
    {
      id: 2,
      thumbnail:
        environment.assUrl +
        "assets/images/maestro/Pandit-Vishwa-Mohan-Bhatt.jpg",
      artist_name: "Pandit Vishwa Mohan Bhatt",
      about_us:
        "Creator of the MOHAN VEENA and the winner of the GRAMMY AWARD, Vishwa Mohan Bhatt has mesmerized the world with his pristine pure, delicate yet fiery music.  It is due to Vishwa's maiden mega effort that he rechristened guitar as MOHAN VEENA, his genius creation and has established it at the top most level in the mainstream of Indian Classical Music scenario, thereby proving the essence of his name VISHWA (meaning the world) and MOHAN (meaning charmer) and indeed, a world charmer he is. Being the foremost disciple of Pt. Ravi Shankar, Vishwa Mohan Bhatt belongs to that elite body of musicians which traces its origin to the Mughal emperor Akbar's court musician TANSEN and his guru the Hindu Mystic Swami Haridas. Vishwa Mohan Bhatt has attracted international attention by his successful Indianisation of the western Hawaiian guitar with his perfect assimilation of sitar, sarod & veena techniques, by giving it an evolutionary design & shape and by adding 14 more strings helping him to take the instrument MOHAN VEENA to unbelievable heights. With blinding speed and faultless legato, Bhatt is undoubtedly one of the most expressive, versatile and greatest slide players in the world. Being a powerhouse performer, Vishwa's electrifying performance always captivates the audience whether in the United States of America, Europe, Gulf countries or his motherland India. Vishwa Mohan has become the cultural ambassador of India by carrying the Herculean task of glorifying and popularizing Indian culture and music throughout the world. Outstanding features of Bhatt's baaj (style) are his natural ability to play the 'Tantrakari Ang' and incorporate the 'Gayaki Ang' on Mohan Veena which is the greatest advantage of this instrument over traditional Indian instruments like sitar, sarod and veena. It was no surprise that Vishwa Mohan with his sheer virtuosity and limitless supply of melodies won the highest music award of the world, the GRAMMY AWARD IN 1994 along with Ry Cooder for their World Music Album, 'A MEETING BY THE RIVER' enhancing his celebrity status not only as a star performer but also as an improviser and a soulful composer. Vishwa Mohan Bhatt has performed extensively in the USA, USSR, Canada, the Great Britain, Germany, Spain, France, Italy, Netherlands, Belgium, Scotland, Switzerland, Denmark, then scaling the Gulf of Dubai, Al-Sharjah, Bahrain, Muscat, Abu Dhabi and throughout India.",
      video: "",
    },
    {
      id: 3,
      thumbnail:
        environment.assUrl + "assets/images/maestro/Pandit-Sajan-Mishra.jpg",
      artist_name: "Pandit Sajan Mishra",
      about_us:
        "Padma Bhushan Pandit Sajan Mishra was born and brought up in Varanasi. Renowned as a part of the legendary classical duo Pandit Rajan and Sajan Mishra, he performed for 54 years since his childhood with his brother, doyen of Benaras gharana Pandit Rajan Mishra, who passed away in April 2021. Pandit Sajan Mishra received his initial musical training from his grandfathers brother, Bade Ram Das Ji Mishra, and also his father, Pandit Hanuman Prasad Mishra, and uncle, sarangi virtuoso, Pandit Gopal Prasad Mishra. He started performing in temples with his brother Pandit Rajan Mishra even before he was a teenager. Pandit Sajan Mishra is part of a 300-year-old lineage of khayal singing of the Banaras gharana. He has been performing to audiences all over India and the world for many years. He has also been a guru to those receiving taleem under the Benaras gharana lineage for decades now. He claims that a lot of his training happened under his brother and partner on stage late Pandit Rajan Mishra. He continues to pass on the Benaras legacy to future generations after the death of his brother, the legendary Pandit Rajan Mishra.",
      video: "",
    },
    {
      id: 4,
      thumbnail: environment.assUrl + "assets/images/maestro/Kiran-Segal.jpg",
      artist_name: "Kiran Segal",
      about_us:
        "Kiran Segal is the foremost exponent of Odissi Dance in India. She is one of the most innovative and outstanding gurus, dancers and choreographers of Odissi Dance today and it is due to this contribution of hers that Odissi has been given a totally different dimension. Her dance is known for its precision and lyricism in movement and the traditional nuances which are fast disappearing. Her abhinaya (expressional dance) has been remarked upon as sensitive & having a quality of muted intensity. Kiran Segal is one of the few top-ranking dancers of India who has taken a sincere interest in inculcating an awareness in Odissi dance amongst the youth of our country. Her lecture demonstrations, workshops and talks held all over India, have contributed immensely in taking this ancient dance form to the remotest corners of India. A nationalist by nature, she has always been at the forefront propagating art & culture through her dance. Her choreography of the Panchakshara Stotram was acclaimed as one of the finest prayers to Lord Shiva in Odissi Dance. Her choreography of the Dashaavataar has been reviewed as powerful and dramatic and her most innovative piece Taalaangiya using 15 dancers dancing to Dhrupad & drumming has been remarked upon as a sculpture in movement. Her most recent contribution to contemporary choreography using Odissi as her base is Whispering Moods and Agni  The Fire Within. Her most recent piece of work is Talking To God using the poems of the Oriya poetess Kuntala Kumari Sabat. Her multi-media presentation of the Ramayana using 13 dancers  an elaborate production using shadow work/dance, puppet and pata-chitra projections has also received widespread acclaim and has been remarked upon as breathtaking. The danseuse has performed on every prestigious international dance festival, platform and stage. For her dedication & contribution to Indian Classical dance, she has been honoured with several titles and awards, some of which are the Sangeet Natak Akademi Award, the Padmashree, the Neelamadhava Award, the Kala Shreshtha  Sammaan, the Indira Gandhi Priyadarshini Award, the Nritya Vilas and the Nritya Saraswati among others. She has educated several teachers & students from schools, colleges & universities from all over India by giving over 1000 lecture-demonstrations to them on Odissi Dance. She continues to look upon Odissi dance as a guiding force in her life.",
      video: "",
    },
    {
      id: 5,
      thumbnail:
        environment.assUrl + "assets/images/maestro/Ehsaan-Noorani.jpg",
      artist_name: "Ehsaan Noorani",
      about_us:
        "Ehsaan Noorani is a famous music composer and guitarist, his knowledge of music is vast and has a huge reservoir of melodious ideas. He is one of the renowned Trio Shankar-Ehsaan-Loy and has achieved great heights as a music composer and as a guitarist. His genres are mainly Blues and Bollywood songs and is the first guitarist from India who was endorsed by Fender Guitars and has a Squier signature model to his name. He also endorses Fractal Audio and DAddario strings and enjoys Blues and Electronica. In 2015, Ehsaan was the co-judge in Indians first English singing show, The Stage, aired on Colors Infinity. At the age of 14, he started learning music in Mumbai and further studied at the Musicians Institute in Hollywood, California from 1985 to 1986. The trio of Shankar-Ehsaan-Loy has won numerous awards at the RD Burman Awards, Star Screen Awards, Filmfare, IIFA and others for exemplary music in movies like Dil Chahta Hai, Kal Ho Na Ho, Bunty Aur Babli, Bhaag Milkha Bhaag including the recent hit Two States.",
      video: "",
    },
    {
      id: 6,
      thumbnail:
        environment.assUrl + "assets/images/maestro/Kavita-Krishnamurthy.jpg",
      artist_name: "Kavita Krishnamurthy",
      about_us:
        "Padmashri Kavita Krishnamurthy is an Indian film playback singer, trained in classical music, she has sung a wide range of classical-based songs  In her career, she has worked with a variety of music composers, including R.D.Burman, Hamsalekha and A.R.Rahman and is also the recipient of four Filmfare Best Female Playback Singer Awards, including 3 consecutive awards in the period 19941996. Her performance as a singer in the film 1942: A Love Story, composed by R.D.Burman won her a lot of popular acclaim. With a string of hits from 1942: A Love Story, Yaraana, Agni Sakshi, Bhairavi and Khamoshi, Kavita established herself as a leading female singer in the mid 1990s. She expanded her area of work and was the main featured soloist in the Global Fusion album released by Warner Bros featuring musicians from five continents and actively started exploring fusion music, travelled around the world including the US, UK, Europe, Africa, Australia, the Far East, the Middle East and South America. She has been making appearances in various music reality shows as a guest judge.",
      video: "",
    },
  ];

  ngOnInit(): void {
    this.getdata();
  }

  constructor(private adivce: AdvisorsService, private dialog: MatDialog) {}

  getdata() {
    this.adivce
      .getAdvisor()
      .pipe(
        map((res: any) => {
          this.advisors = res.details;
          this.advisors.reverse();
          // console.log(this.advisors);
        }),
        catchError((error) => {
          return throwError(error.message || error);
        })
      )
      .subscribe();
  }

  transform(text: string): string {
    const words = text.split(" ");
    if (words.length > 50) {
      return words.slice(0, 50).join(" ") + " .....";
    } else {
      return text;
    }
  }

  openVideo(id: string) {
    this.adivce
      .getAdvisorById(id)
      .pipe(
        map((res: any) => {
          this.advisorsByID = res.details;
          // console.log(this.advisorsByID);
          this.openDialog(
            this.advisorsByID.artist_name,
            this.advisorsByID.about_us,
            this.advisorsByID.thumbnail
          );
        }),
        catchError((error) => {
          return throwError(error.message || error);
        })
      )
      .subscribe();
  }

  hardList(id: number) {
    this.openDialog(
      this.advisorsExtra[id - 1].artist_name,
      this.advisorsExtra[id - 1].about_us,
      this.advisorsExtra[id - 1].thumbnail
    );
  }

  openDialog(title: String, discription: String, img: String) {
    this.dialog.open(AdvisorModalComponent, {
      enterAnimationDuration: "400ms",
      data: {
        title: title,
        discription: discription,
        img: img,
      },
    });
  }

  ngAfterViewInit() {
    this.updateButtonStatus();
  }

  scrollLeft() {
    this.scrollContent.nativeElement.scrollTo({
      left: this.scrollContent.nativeElement.scrollLeft - this.scrollSpeed,
      behavior: "smooth",
    });
    this.updateButtonStatus();
  }

  scrollRight() {
    this.scrollContent.nativeElement.scrollTo({
      left: this.scrollContent.nativeElement.scrollLeft + this.scrollSpeed,
      behavior: "smooth",
    });
    this.updateButtonStatus();
  }

  updateButtonStatus() {
    const scrollElement = this.scrollContent.nativeElement;
    this.isLeftDisabled = scrollElement.scrollLeft === 0;
    this.isRightDisabled =
      scrollElement.scrollLeft + scrollElement.clientWidth ===
      scrollElement.scrollWidth;
  }
}
